<hr
  class={`w-full my-2 border-opacity-25 border-solid border-t-1 border-base-content ${$$props.class}`}
  style={`${$$props.style}`}
/>
